export const createHTMLElementFromString = (html: string): HTMLElement => {
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    return template.content.firstChild as HTMLElement;
};

export const createHTMLElementFromTemplate = (template: HTMLTemplateElement): HTMLElement => {
    return createHTMLElementFromString(template.innerHTML);
};

export const addEventListener = <E extends Event, R = void>(
    element: HTMLElement,
    eventName: string,
    callback: (event: E) => R,
    options?: boolean | AddEventListenerOptions
): void => {
    let targetElement: HTMLElement | Window = element;
    let cleanEventName = eventName;
    if (eventName.startsWith('window|')) {
        targetElement = window;
        cleanEventName = eventName.substring(7);
    }
    else if (eventName.includes('|')) {
        const [targetDirective, remainingEventName] = eventName.split('|', 2);
        if (targetDirective.startsWith('target(') && targetDirective.endsWith(')')) {
            const selector = targetDirective.substring(7, targetDirective.length - 1);
            const selectedElement = document.querySelector(selector);
            if (selectedElement instanceof HTMLElement) {
                targetElement = selectedElement;
            }
        }
        cleanEventName = remainingEventName;
    }
    targetElement.addEventListener(cleanEventName, (event: Event) => callback(event as E), options);
}

/**
 * Sets the value of a field and announces it by a change event, so a live component keeps it in its model.
 */
export const changeValue = (input: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement, value: string): void => {
    if (input.value === value) {
        return;
    }
    input.value = value;
    input.dispatchEvent(new Event('change', {bubbles: true}));
};

/**
 * Parses a computed CSS length in pixels (`"12.5px"`); returns 0 when the value is not a number (`"auto"`, `""`).
 */
export const parsePixels = (value: string): number => {
    const parsed = parseFloat(value.replace('px', ''));
    return isNaN(parsed) ? 0 : parsed;
};
